import PrivateRoute from '@Components/app-layout/PrivateRoute';
import AppRouter from '@Components/app-layout/Router';

import ProfileLayout from './views/my-profile/Layout';

export default function ProfileRoutes() {
  return <AppRouter redirect='/profile'>
    <PrivateRoute path="/profile" component={ProfileLayout} />
  </AppRouter>
}
